import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    IMLPackage,
    IMLPackageVersion,
    ModalResultType,
} from '@models';
import { MLPackagesService } from '@services';

enum MLPackageVersionViewMode {
    InputOutput,
    ReleaseNotes,
}

@Component({
    templateUrl: './mlpackage-versions.modal.html',
    styleUrls: [
        './mlpackage-versions.modal.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    providers: [
        MLPackagesService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MLPackageVersionsModalComponent
    extends UiModalComponent<IMLPackage> {
    public ModelVersionViewMode = MLPackageVersionViewMode;
    public currentModelVersionViewMode?: MLPackageVersionViewMode;
    public selectedModelVersion?: IMLPackageVersion;
    public latestVersions?: IMLPackageVersion[];

    public onClose(result: boolean) {
        const data = result ?
            { type: ModalResultType.Remove } :
            undefined;

        this._dialogRef.close(data);
    }

    public showVersions() {
        this.selectedModelVersion = undefined;
    }

    public showInformation(modelVersion: IMLPackageVersion, mode: MLPackageVersionViewMode) {
        this.currentModelVersionViewMode = mode;
        this.selectedModelVersion = modelVersion;
    }
}
